<template>
  <el-row type="flex" justify="center" v-if="$route.name === 'Proscan'">
    <el-col v-if="params.data.status === 'FAILED'">
      <BIconExclamationTriangle class="bicon" v-show="params.data.info" /> {{ params.data.info }}
    </el-col>
    <el-col v-else>
      {{ params.data.info }}
    </el-col>
  </el-row>
</template>
<script>
import { defineComponent } from 'vue'
import { BIconExclamationTriangle } from 'bootstrap-icons-vue'
export default defineComponent({
  components: { BIconExclamationTriangle }
})
</script>